import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  content: {
    zIndex: 9,
    height: '100%',
    overflowY: 'scroll',
    overflowX: 'hidden',
    padding: 15,
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    scrollBehavior: 'smooth',
    '&::-webkit-scrollbar': {
      width: theme.shape.scrollSize,
      height: theme.shape.scrollSize,
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.scroll,
      borderRadius: theme.shape.scrollRadius,
    },
  },
  header: {
    textAlign: 'right',
    color: '#8092ec',
    padding: '1em 0',
  },
}))

export default useStyles
